import { render, staticRenderFns } from "./ServiceFormCreate.vue?vue&type=template&id=019969ae&scoped=true&"
import script from "./ServiceFormCreate.vue?vue&type=script&lang=js&"
export * from "./ServiceFormCreate.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormCreate.vue?vue&type=style&index=0&id=019969ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019969ae",
  null
  
)

export default component.exports